module.exports = __webpack_public_path__ + "img/step2@2x.c701f3f1.png";